import React from "react";
import '../About/AboutUs.css'
import founderImage from "../../assets/bhai.jpeg"; 
import gandhi from "../../assets/inspriration/gandhi.jpg";
import vinoba from "../../assets/inspriration/vinoba bhave.jpg";
import baba from "../../assets/inspriration/baba amte.jpg";

const About = () => {
  return (
    <div className="about-container">
      {/* About Bar */}
      <div className="about-bar">
        <h1>About Us</h1>
      </div>

      {/* Our Story Section */}
      <section className="our-story">
        <h2>Our Story</h2>
        <p>In the heart of the Buldana district of Maharashtra, a barren stretch of land at the bottom of the Satpuda mountain
           has transformed into a lush green heaven, thanks to the relentless efforts of the Tarunai Foundation in collaboration with Gram Panchyat of Sungaon, Forest Department of Jalgaon Jamod, Mahatma Gandhi Loksewa Sangh. 
           Five years ago, this land, owned by the Mahatma Gandhi Loksewa Sangh, was desolate and echoing the effects of deforestation.
            Guided by Gandhian principles of sustainability, the community came together, planting over 1 lakh trees and counting, 
            reviving species like Salai, Palas, and Neem that were once vanishing. Their work brought not only greenery but 
            also life—birds, butterflies, and wildlife returned, enriching the ecosystem. The revival didn’t stop there;
             poison-free farming began, using natural pests' repelants, biological control measures and manure, while tribal villages like Vadpani saw new roads, water,
              electricity, and healthcare access through community labor. Celebrations of tribal festivals and the preservation 
              of indigenous seeds and wild vegetables intertwined culture with conservation, making this endeavor a heartwarming tale
               of resilience, collaboration, and nature's rebirth.</p>
               <p><b>Collaborations:</b> Gram Panchyat Sungaon, Forest Department Jalgaon Jamod, Samajik Vanikaran Jalgaon Jamod, Gurudev Seva Mandal, Nehru Yuva Kendra Buldhana, Red Swastik Society Jalgaon Jamod, Shriram Kute Guruji Foundation Jalgaon Jamod, Aditi Urban Co-op Credit Society Buldhana, Jankalyan Parivar Jalgaon Jamod.</p>

      </section>

      {/* Founder Section */}
      <section className="founder">
        <div className="founder-left">
          <img src={founderImage} alt="Founder" />
        </div>
        <div className="founder-right">
          <h2>Meet Our Founder</h2>
          <p>
          <b>Manjitsingh Sikh</b> also popularly known as <b>Bhai</b> , a former journalist and dedicated social worker since 1994, took on the challenge of transforming Salaiban a barren piece of land—into a thriving green space. In 2015, he began his mission to bring life back to the land.

Through relentless efforts in tree plantation, water harvesting, and other social initiatives, Bhai has turned Salaiban into a symbol of hope and sustainability. His dedication and hard work stand as an inspiration.
          </p>
        </div>
      </section>

      {/* Video Section */}
      <section className="videos">
        <h2>Our Videos</h2>
        <div className="video-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/aRLIccTQq9k?si=m-5BRz20rf8EuS_w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/c4EdFRDYdrQ?si=EnUpio_yQjCjmD6l" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </section>
           {/* Inspiration Section */}
           <section className="inspiration-section">
        <h2>Our Inspiration</h2>
        <div className="inspiration-images">
          <div className="inspiration-item">
            <img src={gandhi} alt="Mahatma Gandhi" />
            <p>Mahatma Gandhi</p>
          </div>
          <div className="inspiration-item">
            <img src={vinoba} alt="Vinoba Bhave" />
            <p>Vinoba Bhave</p>
          </div>
          <div className="inspiration-item">
            <img src={baba} alt="Dr. Baba Amte" />
            <p>Baba Amte</p>
          </div>
        </div>
      </section>

      {/* Mentors Section */}
      <section className="mentors-team-section">
        <h2>Our Mentors & Team</h2>
        <div className="mentors-team-content">
          <div className="mentors-list-container">
            <h3>Our Mentors</h3>
            <ul className="mentors-list">
              <li>Dr. Vikas Amte</li>
              <li>Dr. Prakash Amte</li>
              <li>Acharya Haribhau Verulkar Guruji</li>
              <li>Ramesh Dane (Chairman, Maharashtra Sarvodaya Mandal)</li>
              <li>Shivcharan Thakur</li>
              <li>Indrajit Deshmukh</li>
              <li>Shanker Bagade</li>
              <li>Adv. Eknath Dagvar (Bhudan Yadnya Mandal)</li>
              <li>Dr. Avinash Savaji</li>
              <li>Sudhakar Aajbe (Chairman, Tilak Rashtriya Vidyalaya)</li>
            </ul>
          </div>
          <div className="team-list-container">
            <h3>Tarunai Foundation team</h3>
            <ul className="team-list">
              <li>Narayan Pithore (Chairman)</li>
              <li>Vitthal Pawar (Vice Chairman)</li>
              <li>Rajendra Kolhe (Secretary)</li>
              <li>Umakant Kandekar (Joint Secretary)</li>
              <li>Avinash Sontakke (Treasurer)</li>
              <li>Suchita Umale(Member)</li>
              <li>Sadhana Pacharne(Member)</li>
              <li>Dr. Rajesh Mirge (Member)</li>
              <li>Adv. Uday Aapte (Member)</li>
              <li>Sanjay Challani (Member)</li>
              <li>Pravin Bate (Member)</li>
              <li>Ramesh Borade (Member)</li>
              <li>Arvind Shingade (Member)</li>
            </ul>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default About;
